import React, {useState, useEffect} from 'react';
import Viewer from 'react-viewer';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import Switch from 'react-bootstrap-switch';
import {Form, Button} from 'react-bootstrap';

const customStyles = {
  overlay: {zIndex: 9999}
};

export default function PhotoStamp(props) {
  useEffect(() => {
    // setImages(props.images);
    setIndex(-1);
    setIndex2(0);
  }, [props.images]);

  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(-1);
  const [index2, setIndex2] = useState(0);
  const currentImage = props.images[index];
  const nextIndex = (index + 1) % props.images.length;
  const nextImage = props.images[nextIndex] || currentImage;
  const prevIndex = (index + props.images.length - 1) % props.images.length;
  const prevImage = props.images[prevIndex] || currentImage;

  const handleClick = (index) => setIndex(index);
  const handleClose = () => setIndex(-1);
  const handleMovePrev = () => setIndex(prevIndex);
  const handleMoveNext = () => setIndex(nextIndex);
  return (
    <div className="row">
      <div className="col-12">
        <Switch
          bsSize={'mini'}
          onText={'lightbox'}
          offText={'viewer'}
          offColor={'success'}
          onChange={(el, state) => {
            state ? props.setStyle('lightbox') : props.setStyle('viewer');
          }}
          value={props.style === 'lightbox'}
        />
        {props.mode && props.mode === 'select' ? (
          <Button
            className="ml-2 btn-xs"
            variant="success"
            onClick={() => {
              props.importPhotoNa();
            }}
          >
            นำเข้ารูปที่เลือกไว้
          </Button>
        ) : (
          <></>
        )}
      </div>
      <div className="row">
        {props.images.map((e, i, arr) => {
          return (
            <div key={i.toString()} className="img-item">
              <div
                className={
                  props.mode && props.mode === 'select'
                    ? 'col-12 mt-2'
                    : 'd-none'
                }
              >
                <Switch
                  className="col-12"
                  bsSize={'mini'}
                  value={e.selected}
                  onChange={(el, state) => {
                    let _temp = arr.map((element) => {
                      if (element.src === e.src) {
                        return {...element, selected: state};
                      } else {
                        return element;
                      }
                    });
                    props.setPhotoNa(_temp);
                    // props.setPhotoNa((prevState) => ({
                    //   ...prevState,
                    //   sele: props.item.vehicleid,
                    //   distanceActual: props.item.distanceActual / 1000,
                    //   totaCostActual: props.item.totaCostActual,
                    //   rate: props.item.rate
                    // }));
                  }}
                />
              </div>
              <img
                alt="aaaaa"
                src={e.src}
                style={{
                  margin: '0.3vh',
                  borderStyle:
                    e.alt === 'UPLOAD' ||
                    e.alt === '#Manual' ||
                    e.alt === '#CRManual' ||
                    (e.checksum && e.checksum === 'VALID IMAGE') ||
                    (e.checksum && e.checksum === 'INVALID IMAGE')
                      ? 'dashed'
                      : 'none',
                  borderColor:
                    e.alt === '#Manual' || e.checksum === 'INVALID IMAGE'
                      ? 'red'
                      : e.alt === '#CRManual'
                      ? 'gold'
                      : e.checksum === 'VALID IMAGE'
                      ? 'green'
                      : 'black',
                  borderWidth: 'medium',
                  maxHeight: 200,
                  maxWidth: 250,
                  padding: '1vh',
                  cursor: 'pointer'
                }}
                onClick={() => {
                  if (props.style === 'lightbox') {
                    handleClick(i);
                  } else {
                    setIndex2(i);
                    setOpen(true);
                  }
                }}
              />
            </div>
          );
        })}
        {!!currentImage && (
          /* @ts-ignore */
          <Lightbox
            reactModalStyle={customStyles}
            mainSrc={currentImage.original}
            imageTitle={currentImage.caption}
            mainSrcThumbnail={currentImage.src}
            nextSrc={nextImage.original}
            nextSrcThumbnail={nextImage.src}
            prevSrc={prevImage.original}
            prevSrcThumbnail={prevImage.src}
            onCloseRequest={handleClose}
            onMovePrevRequest={handleMovePrev}
            onMoveNextRequest={handleMoveNext}
          />
        )}
        {props.images.length !== 0 && (
          <Viewer
            visible={open}
            drag={false}
            onClose={() => {
              setOpen(false);
            }}
            // onMaskClick={() => {
            //     setOpen(false);
            //   }}
            zoomSpeed={0.2}
            zIndex={9999}
            images={props.images}
            activeIndex={index2 === -1 ? 0 : index2}
            downloadable={true}
            downloadInNewWindow={true}
          />
        )}
      </div>

      <div className="input-group">
        <div className="input-group-prepend">
          <div
            className="input-group-text"
            style={{width: 130, backgroundColor: 'green', color: 'black'}}
          >
            เส้นประเขียว
          </div>
        </div>
        <input
          style={{
            textAlign: 'right'
          }}
          disabled
          type="text"
          className="form-control col-6"
          value={
            'รูปที่ระบบตรวจสอบเบื้องต้นแล้วว่า เป็นรูปจริง, ไม่ได้ถูกแก้ไขตัดต่อ'
          }
        />
      </div>
      <div className="input-group">
        <div className="input-group-prepend">
          <div
            className="input-group-text"
            style={{width: 130, backgroundColor: 'black', color: 'white'}}
          >
            เส้นประดำ
          </div>
        </div>
        <input
          style={{
            textAlign: 'right'
          }}
          disabled
          type="text"
          className="form-control col-6"
          value={'รูปแนบ ไม่คำนวนระยะทาง'}
        />
      </div>
      <div className="input-group">
        <div className="input-group-prepend">
          <div
            className="input-group-text"
            style={{width: 130, backgroundColor: 'red', color: 'white'}}
          >
            เส้นประแดง
          </div>
        </div>
        <input
          style={{
            textAlign: 'right'
          }}
          disabled
          type="text"
          className="form-control col-6"
          value={'รูปอัพโหลดโดยพนักงาน, หรือรูปผิดปกติ'}
        />
      </div>
      <div className="input-group">
        <div className="input-group-prepend">
          <div
            className="input-group-text"
            style={{width: 130, backgroundColor: 'gold', color: 'black'}}
          >
            เส้นประเหลือง
          </div>
        </div>
        <input
          style={{
            textAlign: 'right'
          }}
          disabled
          type="text"
          className="form-control col-6"
          value={'รูปอัพโหลดโดย CR'}
        />
      </div>
    </div>
  );
}
